/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const history = useHistory();
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://alfaroabogados.blogspot.com/?m=1"
                className={classes.block}
                target="_blank"
              >
                Información de Interés
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
               // href="http://www.alfaroasociados.com.co/quienes-somos"
               onClick={() => history.push("/quienes-somos")}
               className={classes.block}
                target="_blank"
                
              >
               Quienes Somos
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                onClick={() => history.push("/sedes")}
                className={classes.block}
                target="_blank"
              >
               Sedes
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="http://proceso.alfaroasociados.com.co/contactenos"
                className={classes.block}
                target="_blank"
              >
               Contactenos
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()} , Derechos Reservados Alfaro Abogados Asociados
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
